import { connect } from 'react-redux';
import { getProfile } from 'core/slices/users';
import ProtectedRoute from '../../../components/providers/ProtectedRoute';
import { isAuthenticated, isLoadingProfile, profile } from 'core/selectors';

export default connect(
  state => ({
    isLoadingProfile: isLoadingProfile(state),
    isAuthenticated: isAuthenticated(state),
    profile: profile(state),
  }),
  { getProfile },
)(ProtectedRoute);
